// FORM_VERSION (docs/DECISIONS.md, 20 Oct 2026): Book & pay's layout. 'v3'
// unless the layout's gwmc:form tag says 'v2' (the rollback, kept for one
// release; ?form=v2 for one browser session). Every PostHog event carries it
// as the form_version super property (registered in layouts/gwmc), so the
// two can be read before and after.
export const formVersion = () =>
  typeof document !== 'undefined' && document.querySelector('meta[name="gwmc:form"]')?.getAttribute('content') === 'v2' ? 'v2' : 'v3'
